module.exports = __webpack_public_path__ + "media/components/lesson4/statics/receiveMessage-2b102105f78b00c5ddf440df8796a486.png";